import { executeCapability } from '../utils/capabilityExecute'

export interface UpdatesStatus {
  showUpdates: boolean;
  version: string;
  content: string;
}

export const updatesService = {
  async getStatus(): Promise<UpdatesStatus> {
    return executeCapability<UpdatesStatus>({
      app: 'global',
      capability: 'updates.status',
      input: {},
    })
  },

  async markSeen(version: string): Promise<void> {
    await executeCapability({
      app: 'global',
      capability: 'updates.seen',
      input: { version },
    })
  },
};
